









































import { Component, Vue, Mixins } from 'vue-property-decorator';
import FooterMenu from '@/components/FooterMenu.vue';
import { State } from 'vuex-class';
import { UserState } from '@/store/types';
import { SignInArguments, ForgottenPasswordArgs, ForgottenPasswordCodeArgs, CreateUserArgs } from '@/common/apis/AccountApi';
import UserMixin from '@/mixins/UserMixin';
import { Client } from '@/common/apis/AccountApi';
import ApiProvider from '@/common/apis/ApiProvider';
@Component({
    components: {
        FooterMenu,
    },
})
export default class Login extends Vue {
    public loading: boolean = false;
    public error: string = '';
    public successfullyCreated: boolean = false;

    // Fields
    public email: string = '';
    public name: string = '';
    public newPassword: string = '';
    public retypePassword: string = '';

    public async create() {
        if (this.newPassword !== this.retypePassword) {
            this.error = this.$t('create-user.error-passwords-must-match').toString();
            return;
        }

        try {
            this.error = '';
            this.loading = true;
            const api = ApiProvider.getAccontApi();
            await api.createUser(new CreateUserArgs({
                fullName: this.name,
                password: this.newPassword,
                email: this.email,
            }));
            this.successfullyCreated = true;

        } catch (e) {
            if (e.response && e.response.data && e.response.data.message) {
                this.error = e.response.data.message as string;
            }
        }
        this.loading = false;
    }
    public async logon() {
        this.loading = true;
        this.$store.dispatch('user/login', new SignInArguments({
            email: this.email,
            password: this.newPassword,
        }))
        .then(() => {
            this.loading = false;
            this.$router.replace('/devices');
        })
        .catch((e) => {
            this.loading = false;
            if (e.response && e.response.data && e.response.data.message) {
                this.error = e.response.data.message as string;
            }
        });
    }
}
